import React, { useState, useEffect } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { companyInfo } from '../mockData';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg py-2' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => handleNavigation('/')}>
            <img
              src={companyInfo.logo}
              alt={companyInfo.name}
              className="h-12 w-12 object-contain"
            />
            <div className="hidden sm:block">
              <h1 className="text-xl font-bold text-gray-900">{companyInfo.name}</h1>
              <p className="text-xs text-orange-600">Varanasi's Trusted Travel Partner</p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-6">
            <button
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vehicles')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Our Fleet
            </button>
            <button
              onClick={() => scrollToSection('destinations')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Destinations
            </button>
            <button
              onClick={() => handleNavigation('/payment')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Payment
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-gray-700 hover:text-orange-600 font-medium transition-colors"
            >
              Contact
            </button>
            <a href={`tel:${companyInfo.phone[0]}`}>
              <Button className="bg-orange-600 hover:bg-orange-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col gap-3">
            <button
              onClick={() => scrollToSection('home')}
              className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors py-2"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('vehicles')}
              className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors py-2"
            >
              Our Fleet
            </button>
            <button
              onClick={() => scrollToSection('destinations')}
              className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors py-2"
            >
              Destinations
            </button>
            <button
              onClick={() => handleNavigation('/payment')}
              className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors py-2"
            >
              Payment
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-left text-gray-700 hover:text-orange-600 font-medium transition-colors py-2"
            >
              Contact
            </button>
            <a href={`tel:${companyInfo.phone[0]}`}>
              <Button className="w-full bg-orange-600 hover:bg-orange-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Call Now
              </Button>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
